export default __webpack_public_path__ + "static/media/BugCatcherDash.b1b148e6.png";